import styled from 'styled-components';

export const MainContainer = styled.div`
    background: #f9f9f9;
    padding-bottom: 50px;
`;

export const MainWrapper = styled.div`
    display: grid;
    z-index: 1;
    max-width: 1000px;
    margin-right: auto;
    margin-left: auto;
    padding: 10px 24px;
    justify-content: center;
`;

export const MainRow = styled.div`
    display: grid;
    grid-template-columns: repeat(1,1fr);
    grid-gap: 10px;
    grid-auto-rows: minmax(500px,auto);

    @media screen and (max-width: 775px) {
        grid-template-columns: 1fr;
        grid-template-rows: repeat(2, 1fr);
        text-align: center;
    }
`;

export const Column1 = styled.div`
    width: 15rem;
    margin-top: 60px;
    padding: 0 25px;
    justify-self: center;
    grid-column: 1 / 3;
    grid-row: 1;

    @media screen and (max-width: 875px) {
        width: 100%;
        grid-column: none;
        grid-row: 1 / 2;
    }
`;

export const Column2 = styled.div`
    width: 50rem;
    margin-top: 30px;
    padding: 0 25px;
    justify-self: start;
    grid-column: 3 / 3;
    grid-row: 1;

    @media screen and (max-width: 1125px) {
        width: 100%;
    }

    @media screen and (max-width: 875px) {
        width: 100%;
        grid-column: none;
        grid-row: 2 / 2;
    };
`;

export const InfoWrapper = styled.div`
    box-shadow: 0 6px 10px rgba(0,0,0,.05);
    border: 1px solid #d6dee6;
    border-radius: 4px;
    margin-bottom: 20px;
`;

export const TitleAside = styled.h3`
    color: #ad625c;
    font-weight: 700;
    padding: 1rem;
    background-color: rgba(179, 191, 201, 0.15);
`;

export const InfoAside = styled.div`
    width: 440px;
    height: 100px;
    text-align: left;
    padding: 0 1rem;
`;

export const Info = styled.span`
    display: block;
    font-size: 15px;
    color: #999999;
    margin: 10px 0 0 5px;
`;

export const InfoImg = styled.img`
    display: inline;
    width: 50px;
    margin: 15px 10px 0 0;
    border-radius: 50%;
`;

export const TitleWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(1,1fr);
`;

export const Title = styled.h1`
    grid-column: 1 / 3;
    grid-row: 1;
    margin-top: 24px;
    font-size: 2rem;
    line-height: 1.1;
    font-weight: 500;
    text-align: left;
    margin-bottom: 25px;
    color: #606c38;
`;

export const BtnWrapper = styled.div`
    grid-column: 3 / 3;
    grid-row: 1;
    margin-top: 30px;
`;

export const BtnLink = styled.button`
    border-radius: 4px;
    background: #606c38;
    padding: 10px 22px;
    color: #f9f9f9;
    font-size: 16px;
    font-weight: 500;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;
    margin-left: 10px;
    
    &:hover {
        transition: all 0.2s ease-in-out;
        background: #ad625c;
        transform: scale(1.02);
    }
`;

export const SessionWrapper = styled.div`

`;

export const SessionFilter = styled.div`
    display: flex;
    align-items: center;
`;

export const Filter = styled.select`
    height: 32px;
    width: 196px;
    font-size: 16px;
    border-radius: 4px;
    padding-left: 14px;
    border: 1px solid #606c38;
    color: #6b6b6b;
    background: rgba(179, 191, 201, 0.15);
`;

export const Line = styled.div`
    margin: 30px 0;
    border-top: 1px solid #606c38;
`;

export const SessionInfo = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr 0.1fr;
    height: auto;
    box-shadow: 0 6px 10px rgba(0,0,0,.05);
    border: 1px solid #d6dee6;
    border-radius: 4px;
    margin-bottom: 20px;

    @media screen and (max-width: 775px) {
        grid-template-columns: repeat(2,1fr);
        padding-right: 20px;
    };
`;

export const ImgProfessional = styled.img`
    grid-column: 1 / 2;
    grid-row: 1;
    justify-self: center;
    width: 100px;
    margin: 20px;
    border-radius: 50%;
`;

export const InfoSession = styled.div`
    grid-column: 2 / 2;
    grid-row: 1;
    align-self: center;

    @media screen and (max-width: 775px) {
        text-align: left;
    };
`;

export const InfoDetail = styled.span`
    display: block;
    font-size: 18px;
    color: #999999;
    margin-bottom: 10px;

    &#status {
        color: #606c38;
        font-weight: bold;
        font-size: 20px;
    }

    &#time {
        color: #2e2e2e;
        font-weight: bold;
        font-size: 25px;
    }
`;